import { Component, OnInit, AfterViewInit } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import {
  MenuService,
  UserService,
  SettingsService,
} from "../../../../service/service.index";
import { Appsettings } from "../../../../configuration/appsettings";

// COMPONENT SERVICES
import { AdminHeaderService } from "../admin-header/admin-header.service";

// SERVICES
import { StorageService } from "../../../../service/service.index";
import { AdminNavService } from "./admin-nav.service";
import swal from "sweetalert2";
//import { AngularFireMessaging } from '@angular/fire/messaging';
import { JoyrideService } from "ngx-joyride";

import { User } from "../../../../models/security/user.model";

@Component({
  selector: "app-admin-nav",
  templateUrl: "./admin-nav.component.html",
  styleUrls: ["./admin-nav.component.scss"],
})
export class AdminNavComponent implements OnInit, AfterViewInit {
  menu: any = [];
  menuRes: any[];
  profileImage: string;
  working = false;
  coupon: string;
  coupontrue: boolean;
  public user: User;
  constructor(
    public _srvMenu: MenuService,
    public _srvHeader: AdminHeaderService,
    public _srvStorage: StorageService,
    public _srvAdminNav: AdminNavService,
    //private afMessaging: AngularFireMessaging,
    public _srvUser: UserService,
    public _srveSettings: SettingsService,
    private joyride: JoyrideService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    const profileImg =
      _srvStorage.profileImage !== null
        ? _srvStorage.profileImage
        : "assets/img/profileimg/profile-placeholder.png";
    this.profileImage = profileImg;
    this.menuRes = _srvMenu.getMenu();
    this.menu = _srvMenu.getMenu();
    console.info("MENU");
    console.log(this.menu);
    console.log(this._srvStorage.rol);
    

    const data = JSON.parse(this._srvStorage.nodes);
    const filtrado = data.filter((item) => item.id !== 143 && item.id !== 144);
    this._srveSettings.aplicarTema(filtrado);

    if (this._srvStorage.email === "usuarioprueba@hachette.com.mx") {
      this.filterEmailMenu();
    }

    if( this._srvStorage.rol == 'Alumno Bachillerato'){
      this.filtrarMenuAlumnoBachiller();
    }

    this.coupon = this._srvStorage.showCoupon;
    this.coupontrue = this._srvStorage.showCoupon ? true : false;

    if (
      !this.coupontrue &&
      this._srvStorage.rol == "Profesor que imparte cursos"
    ) {
      console.log("hola soy profesor");

      this.getUserProfile();
    }
    this.matIconRegistry.addSvgIcon(
      "whatsapp",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "../../../../../assets/fonts/whatsapp.svg"
      )
    );
  }

  ngOnInit() {
    this._srvAdminNav.setUrlBackButton([]);
    if (this._srvStorage.showTour === 0) {
      this._srvStorage.showTour = 1;
      this.joyride.startTour({
        steps: ["firstSteps1"],
        customTexts: {
          next: ">>",
          prev: "<<",
          done: "Cerrar",
        },
      });
    }
    // this.joyride.startTour(
    //   { steps: ['firstSteps1']}
    // )
    //   console.log('hola menu');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this._srvHeader.setNotifications();
    });
  }

  filtrarMenuAlumnoBachiller() {
    this.menu = this.menuRes.filter((x) => x.title != "Libros de texto en PDF");
    this.menu = this.menu.filter((x) => x.title != "Libros de texto descargables");
    console.info("filtrarMenuAlumnoBachiller");
    
    console.log(this.menu);
    
  }


  filterEmailMenu() {
    this.menu = this.menuRes.filter((x) => x.title == "Libros de texto en PDF");
    console.info("filterEmailMenu");

    console.log(this.menu);
  }

  getNotifications() {
    this._srvHeader.setNotifications();
  }

  public onCloseMenu() {
    this._srvAdminNav.openedMenu = !this._srvAdminNav.openedMenu;
  }

  sharedReferredCode(social: string) {
    const codigo = this._srvStorage.showCoupon;
    const endMessage =
      " lo puedes utilizar para registrarte en la plataforma https://hlmra.com/  y obtener $50 de bonificación.";
    const bodyMessage = encodeURI(
      "Mi código referido es: " + codigo + endMessage
    );
    let url = "";

    if (social === "whatsapp") {
      url = "https://api.whatsapp.com/send?text=" + bodyMessage;
    } else if (social === "mail") {
      const subject = encodeURI(
        "Codigo referido de la plataforma https://hlmra.com/"
      );
      url = `mailto:?subject=${subject}&body=${bodyMessage}`;
    }

    window.open(url, "_blank");
  }

  copyMessage(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = this._srvStorage.showCoupon;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    swal(Appsettings.APP_NAME, "Código copiado correctamente", "success");
  }

  // Obtener datos del perfil
  getUserProfile() {
    this.working = true;

    this._srvUser.getProfileData().subscribe(
      (res) => {
        if (res.success) {
          const user = res.data;
          const coupon = this.makeRandom();
          const USER = {
            id: user.id,
            fullName: user.fullName,
            birthDay: user.birthday,
            gender: user.gender,
            contry: user.state.city.id,
            stateId: user.state.id,
            email: user.email,
            key: user.key,
            institution: user.institution,
            coupon: coupon,
            amount: 100,
          };

          this.updateCode(USER);
        }

        this.working = false;
      },
      (err) => {
        this.working = false;
      }
    );
  }

  updateCode(USER: any): void {
    this._srvUser.update(USER).subscribe(
      (res) => {
        if (res.success) {
          this._srvStorage.showAmount = USER["amount"];
          this._srvStorage.showCoupon = USER["coupon"];
          this.coupontrue = true;
          console.log("Exito: " + res.message);
        } else {
          console.log("Error: " + res.message);
        }
        this.working = false;
      },
      (err) => {
        console.log("Problemas al realizar el registro", "SAIL", "error");
        this.working = false;
      }
    );
  }

  makeRandom() {
    const now = new Date();
    var millis = now.getTime() + now.getTimezoneOffset() * 60000;

    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + millis;
    const lengthOfCode = 6;

    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
}
